import React from 'react'

const ContactUs = () => {
  return (
    <div className='container py-4'>
      <div className='bg-light p-4 rounded shadow-sm'>
        <h1 className='text-2xl font-bold mb-4'>Contact Us</h1>
        <p>
          If you have any questions, feedback, or concerns, please reach out to
          us:
        </p>
        <ul className='list-disc ml-6 my-4'>
          <li>
            <strong>Email:</strong> info@teslabird.com
          </li>
          {/* <li>
            <strong>Phone:</strong> +91-XXXXXXXXXX
          </li>*/}
          <li>
            <strong>Address:</strong> 3rd Floor,Site No. 74, Mass Complex, 15th
            Cross Road Sarakki Industrial Area, No. 74, 15th Cross Rd, Sarakki
            Industrial Layout, RBI Layout, 3rd Phase, J. P. Nagar, Bengaluru,
            Karnataka 560078
          </li>
        </ul>
        <p>
          Our support team is available from 9:00 AM to 6:00 PM IST, Monday to
          Friday.
        </p>
      </div>
    </div>
  )
}

export default ContactUs
